/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Sample_ShortInputs */

const en_btn_sample_short = /** @type {(inputs: Btn_Sample_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample`)
};

const ko_btn_sample_short = /** @type {(inputs: Btn_Sample_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`샘플`)
};

const ja_btn_sample_short = /** @type {(inputs: Btn_Sample_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンプル`)
};

/**
* | output |
* | --- |
* | "Sample" |
*
* @param {Btn_Sample_ShortInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const btn_sample_short = /** @type {((inputs?: Btn_Sample_ShortInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Sample_ShortInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_sample_short(inputs)
	if (locale === "ko") return ko_btn_sample_short(inputs)
	return ja_btn_sample_short(inputs)
});